export const canEditDelete = (date: string, now?: number) => {
  const MILLISECONDS_IN_MINUTES = 60000;
  const MAX_MINUTES = 15;
  const difference = (now ?? Date.now()) - Date.parse(date);

  return difference / MILLISECONDS_IN_MINUTES <= MAX_MINUTES;
};
